module.exports = __webpack_public_path__ + "static/media/linkp.ee074e59.jpg";